"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SchemaType_1 = require("./model/contract/SchemaType");
var field_configuration_json_1 = __importDefault(require("./field-configuration.json"));
exports.fieldConfiguration = field_configuration_json_1.default;
var text_json_1 = __importDefault(require("./text.json"));
exports.text = text_json_1.default;
function includes(array, element) {
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var e = array_1[_i];
        if (element === e)
            return true;
    }
    return false;
}
function values(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
var Schema = /** @class */ (function () {
    function Schema(schemaType) {
        if (!includes(values(SchemaType_1.SCHEMA_TYPES), schemaType)) {
            throw new Error("Unrecognized schemaType \"" + schemaType + "\". Valid schema types are: " + Object.keys(SchemaType_1.SCHEMA_TYPES)
                .map(function (key) { return ({ name: key, value: SchemaType_1.SCHEMA_TYPES[key] }); })
                .map(function (_a) {
                var name = _a.name, value = _a.value;
                return value + " (" + name + ")";
            })
                .join(", "));
        }
        this.type = schemaType;
        this.text = getLabels(this.type);
        this.typeName = SchemaType_1.SCHEMA_TYPE_NAMES[this.type];
        this.conditionQuestions = (field_configuration_json_1.default.conditionQuestions[this.typeName] || field_configuration_json_1.default.conditionQuestions.Default);
        this.validation = field_configuration_json_1.default.validation;
        this._enableFields = field_configuration_json_1.default.enableFields;
    }
    Schema.prototype.isEnabled = function (sectionName, fieldName) {
        var section = this._enableFields[sectionName];
        if (!section)
            return false;
        var field = section[fieldName];
        if (!field)
            return false;
        return typeof field[this.typeName] === "boolean"
            ? field[this.typeName]
            : field.Default;
    };
    Schema.prototype.getSectionType = function (sectionName) {
        var _a = this.text, sections = _a.sections, sectionTypes = _a.sectionTypes;
        var section = sections[sectionName];
        if (!section)
            return null;
        var typeName = section.type;
        var type = sectionTypes[typeName];
        return type;
    };
    Schema.prototype.getSectionLabel = function (sectionName) {
        var section = this.getSectionType(sectionName);
        if (!section)
            return null;
        return section.label;
    };
    Schema.prototype.getFieldType = function (sectionName, fieldName) {
        var section = this.getSectionType(sectionName);
        if (!section)
            return null;
        return section.fields[fieldName] || null;
    };
    Schema.prototype.getFieldLabel = function (sectionName, fieldName) {
        var type = this.getFieldType(sectionName, fieldName);
        if (!type)
            return null;
        return type.label;
    };
    Schema.prototype.getFieldPlaceholder = function (sectionName, fieldName) {
        var type = this.getFieldType(sectionName, fieldName);
        if (!type)
            return null;
        return type.placeholder;
    };
    Schema.prototype.getFieldDescription = function (sectionName, fieldName) {
        var type = this.getFieldType(sectionName, fieldName);
        if (!type)
            return null;
        return type.description;
    };
    Schema.prototype.getFieldValidation = function (sectionName, fieldName) {
        var sections = this.text.sections;
        var sectionTypes = this.validation.sectionTypes;
        var section = sections[sectionName];
        var typeName = section.type;
        if (!(typeName in sectionTypes))
            return {};
        var sectionValidation = sectionTypes[typeName];
        if (!(fieldName in sectionValidation))
            return {};
        return sectionValidation[fieldName];
    };
    return Schema;
}());
exports.Schema = Schema;
function getFieldValue(source, schemaType) {
    return source[SchemaType_1.SCHEMA_TYPE_NAMES[schemaType]] || source.Default;
}
function getField(source, schemaType) {
    var keys = Object.keys(source);
    var result = keys
        .map(function (key) { return ({ key: key, value: getFieldValue(source[key], schemaType) }); })
        .reduce(function (acc, _a) {
        var key = _a.key, value = _a.value;
        acc[key] = value;
        return acc;
    }, {});
    return result;
}
function getLabels(schemaType) {
    var sectionTypes = text_json_1.default.sectionTypes, sections = text_json_1.default.sections, subtitle = text_json_1.default.subtitle, x = __rest(text_json_1.default, ["sectionTypes", "sections", "subtitle"]);
    return __assign({}, x, { sectionTypes: Object.keys(sectionTypes)
            .map(function (key) { return ({
            key: key,
            sectionType: sectionTypes[key],
        }); })
            .map(function (_a) {
            var key = _a.key, _b = _a.sectionType, label = _b.label, fields = _b.fields, sectionType = __rest(_b, ["label", "fields"]);
            return ({
                key: key,
                sectionType: __assign({}, sectionType, { label: getFieldValue(label, schemaType), fields: Object.keys(fields)
                        .map(function (key) { return ({
                        key: key,
                        field: fields[key],
                    }); })
                        .map(function (_a) {
                        var key = _a.key, field = _a.field;
                        return ({
                            key: key,
                            field: getField(field, schemaType),
                        });
                    })
                        .reduce(function (acc, _a) {
                        var key = _a.key, field = _a.field;
                        acc[key] = field;
                        return acc;
                    }, {}) }),
            });
        })
            .reduce(function (acc, _a) {
            var key = _a.key, sectionType = _a.sectionType;
            acc[key] = sectionType;
            return acc;
        }, {}), sections: sections, subtitle: getFieldValue(subtitle, schemaType) });
}
//# sourceMappingURL=common.js.map